<template>
  <div class="cf-title-separator">
    <p
      v-if="!omitTitle"
      class="cf-title-separator__title"
    >
      <slot>
        {{ titleText }}
      </slot>
    </p>
  </div>
</template>


<script>
  export default {
    name: 'CfTitleSeparator',

    props: {
      titleText: {
        type: String,
        default: 'or'
      },

      omitTitle: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
